var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "saas-cgvu px-2 pt-2 pb-0" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "header",
        { staticClass: "header px-1 flex-column mb-3" },
        [
          _c("SaasIcon", {
            staticClass: "logo secondary-blue",
            attrs: { icon: "svgLogoSellsyText", width: 128, height: 28 }
          }),
          _vm._v(" "),
          _vm.isAcceptedTerms
            ? _c(
                "a",
                {
                  staticClass: "back-link grey-link semibold fs-3 flex-level",
                  attrs: { href: "/" }
                },
                [
                  _c("i", { staticClass: "el-icon-arrow-left semibold" }),
                  _vm._v("Retour")
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container m-auto" },
        [
          _c("h1", { class: { "mb-5": !_vm.isAcceptedTerms } }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Conditions Générales de Vente et d’Utilisation (CGVU)"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.isAcceptedTerms
            ? _c("el-alert", {
                staticClass:
                  "cgvu-accepted-message p-2 mb-5 primary-05-bkg gray-100 fs-3 b-1-primary-10",
                attrs: {
                  title: _vm.acceptedTermsMessage,
                  type: "info",
                  closable: false
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.terms.url
            ? _c("embed", {
                staticClass: "pdf-embed",
                class: { "cgvu-accepted": _vm.isAcceptedTerms },
                attrs: {
                  src: _vm.terms.url + "#zoom=80",
                  type: "application/pdf"
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }